module.exports = __webpack_public_path__ + "img/Collect Money.269d0f56.svg";